<template>
  <div
    class="container-fluid h-100 d-flex flex-column"
    :class="{ 'bg-warning': failure, 'bg-success': success }"
  >
    <div class="row h-100 align-items-center justify-content-center">
      <card
        v-if="paymentSummary"
        class="col col-md-3 payment-result pb-2 ml-3 ml-md-0 mr-3 mr-md-0"
      >
        <a href="https://www.smartbooks365.com" class="text-muted">
          <img
            :src="require('@/assets/img/logo-dark.png')"
            class="pt-3 pb-3 pl-5 pr-5"
          />
        </a>
        <hr />
        <p class="payment-result__invoice-number">
          {{ $t("message.invoiceNumber") }}:
          <strong>{{ paymentSummary.number || "Not Available" }}</strong>
        </p>
        <hr />
        <div v-if="success">
          <p class="payment-result__total">
            <strong>{{ paymentSummary.total }}</strong>
          </p>
          <p class="p-1">{{ $t("message.paymentSuccessfullyPaidTo") }}</p>
          <p class="payment-result__company-name">
            <strong>{{ paymentSummary.companyName }}</strong>
          </p>
        </div>
        <div v-if="failure">
          <p class="payment-result__error-message">
            {{ $t("message.paymentFailed") }}
            <a
              href="https://www.smartbooks365.com/support"
              class="text-warning mt-5"
              >Smartbooks Support</a
            >.
          </p>
        </div>
        <a
          href="https://www.smartbooks365.com"
          target="_blank"
          class="text-muted"
          >www.smartbooks365.com</a
        >
      </card>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      loader: null,
      success: false,
      failure: false
    };
  },
  methods: mapActions(["getPaymentSummary"]),
  computed: mapGetters(["paymentSummary"]),
  async created() {
    const token = decodeURIComponent(this.$route.query.token);
    const { success, failure } = this.$route.query;

    if (!token || (success === undefined && failure === undefined)) {
      return this.$router.push("/");
    }

    try {
      this.loader = this.$loading.show({ color: "white" });
      this.success = !!success;
      this.failure = !!failure;

      await this.getPaymentSummary(token);
    } catch (error) {
      this.$notify({
        type: "danger",
        title: this.$t("message.error"),
        text:
          (error && error.message) ||
          String(error) ||
          this.$t("message.somethingWentWrong")
      });
    } finally {
      if (this.loader) {
        this.loader.hide();
      }
    }
  }
};
</script>
